export function fontSize(switchingSizeEl) {
  $(switchingSizeEl)
    .children()
    .on("click", function () {
      if ($(this).attr("data-txt-size")) {
        $(this).siblings("button").removeClass("active");
        $(this).addClass("active");
        if ($(this).attr("data-txt-size") === "small") {
          $("html").css("font-size", "100%");
          $("span[data-txt-view=size]").text("標準");
        }
        if ($(this).attr("data-txt-size") === "medium") {
          $("html").css("font-size", "115%");
          $("span[data-txt-view=size]").text("大");
        }
        if ($(this).attr("data-txt-size") === "large") {
          $("html").css("font-size", "130%");
          $("span[data-txt-view=size]").text("特大");
        }
      }
    });
}
